/**
 * Country Profile translations - French
 */

export const countryProfile = {
  countryProfile: {
    // Page structure
    pageTitle: 'Profil du Pays',
    backToRankings: 'Retour aux Classements',
    viewFullProfile: 'Voir le Profil Complet',
    
    // Hero section
    yfiScore: 'Indice des Futurs de la Jeunesse',
    vsGlobal: 'vs Moyenne Mondiale',
    classification: 'Classification',
    region: 'Région',
    
    // Quick stats
    youthPopulation: 'Population Jeune',
    jciMembers: 'Membres JCI',
    jciSince: 'JCI Depuis',
    neetRate: 'Taux NEET',
    
    // Section titles
    demographics: 'Démographie & Population',
    jciPresence: 'Présence JCI',
    dimensionAnalysis: 'Analyse Dimensionnelle',
    mentalHealth: 'Santé Mentale',
    workforce: 'Travail & Éducation',
    entrepreneurship: 'Entrepreneuriat',
    keyPrograms: 'Programmes & Organisations Clés',
    sdgAlignment: 'Alignement ODD',
    recommendations: 'Recommandations Stratégiques',
    communityImpact: 'Impact Communautaire',
    
    // Demographics labels
    totalPopulation: 'Population Totale',
    medianAge: 'Âge Médian',
    urbanPopulation: 'Population Urbaine',
    genderDistribution: 'Répartition par Genre',
    racialComposition: 'Composition Raciale',
    incomeDistribution: 'Distribution des Revenus',
    
    // Racial composition
    pardo: 'Pardo (Métis)',
    preto: 'Preto (Noir)',
    branco: 'Branco (Blanc)',
    other: 'Autres',
    
    // Income levels
    highIncome: 'Revenu Élevé',
    upperMiddle: 'Moyen-Supérieur',
    lowerMiddle: 'Moyen-Inférieur',
    lowIncome: 'Revenu Faible',
    
    // JCI Presence
    affiliationYear: "Année d'Affiliation",
    currentMembers: 'Membres Actuels',
    yearOverYearGrowth: 'Croissance Annuelle',
    historicalPeak: 'Pic Historique',
    memberProfile: 'Profil des Membres',
    ageDistribution: 'Répartition par Âge',
    educationLevel: "Niveau d'Éducation",
    genderBalance: 'Équilibre des Genres',
    motivationLevel: 'Niveau de Motivation',
    higherEducation: 'Enseignement Supérieur',
    postGraduate: 'Post-Diplôme',
    mastersOrHigher: 'Master ou Supérieur',
    veryMotivated: 'Très Motivé',
    motivated: 'Motivé',
    neutral: 'Neutre',
    demotivated: 'Démotivé',
    
    // Challenges
    keyChallenges: 'Défis Clés',
    mentalHealthCrisis: 'Crise de Santé Mentale',
    climateAnxiety: 'Anxiété Climatique',
    youthAnxiety: 'Anxiété des Jeunes',
    frequentSadness: 'Tristesse Fréquente',
    frequentNervousness: 'Nervosité Fréquente',
    adolescentDisorders: 'Adolescents avec Troubles',
    girlsAffected: 'Filles Affectées',
    boysAffected: 'Garçons Affectés',
    highestGlobally: 'Plus Élevé Mondialement',
    neetPopulation: 'Jeunes NEET',
    youth: 'Jeunes',
    intersectionalGap: 'Écart Intersectionnel',
    blackBrownWomen: 'Femmes Noires/Métisses',
    whiteMen: 'Hommes Blancs',
    
    // Workforce labels
    // Workforce labels
    literacyCrisis: "Taux d'Alphabétisation (2e Année)",
    higherEducationGap: "Écart d'Enseignement Supérieur",
    intersectionalNeet: 'NEET Intersectionnel',
    
    // Entrepreneurship labels
    blackEntrepreneurs: 'Entrepreneurs Noirs',
    informalSector: 'Dans le Secteur Informel',
    microentrepreneurs: 'Micro-entrepreneurs (MEI)',
    earlyStageEntrepreneurship: 'Entrepreneuriat en Phase Initiale',
    businessSurvivalRate: 'Survie des Entreprises (2 ans)',
    
    // Programs
    programName: 'Programme',
    programFocus: 'Focus',
    programImpact: 'Impact',
    
    // SDG
    sdgInitiatives: 'Initiatives Clés',
    
    // Recommendations
    urgentPriorities: 'Priorités Urgentes (0-6 mois)',
    mediumTermGoals: 'Objectifs à Moyen Terme (6-12 mois)',
    longTermVision: 'Vision à Long Terme (1-3 ans)',
    
    // Common
    years: 'ans',
    million: 'millions',
    thousand: 'mille',
    percent: '%',
    ofPopulation: 'de la population',
    source: 'Source',
    dataNote: "Données du Rapport d'Impact JCI 2025, Atlas das Juventudes, IBGE, OMS",
    
    // Not found
    notFound: 'Profil du pays non trouvé',
    notFoundDescription: "Le profil du pays demandé n'est pas encore disponible.",
    browseRankings: 'Parcourir les Classements',

    // NEW: Research Sources Section
    dataSources: 'Sources de Recherche',
    dataSourcesDescription: 'Sources de données primaires utilisées dans ce profil de pays',
    primarySources: 'Sources Primaires',
    methodology: 'Méthodologie',
    sampleSize: "Taille de l'Échantillon",
    confidenceLevel: 'Niveau de Confiance',
    organization: 'Organisation',
    researchYear: 'Année',
    respondents: 'répondants',
    
    // NEW: Violence & Safety Section
    violenceSafety: 'Violence et Sécurité',
    violenceSafetyDescription: 'Indicateurs de sécurité critiques affectant la jeunesse brésilienne',
    youthHomicideShare: 'Part des Homicides de Jeunes',
    ofAllHomicides: 'de tous les homicides',
    racialDisparity: 'Disparité Raciale',
    blackYouthMurderRisk: 'Risque de meurtre des jeunes noirs',
    timesHigher: 'fois plus élevé que les jeunes blancs',
    policeViolence: 'Violence Policière',
    policeViolenceVictims: 'des victimes de violence policière sont noires',
    lgbtqiaViolence: 'Violence LGBTQIA+',
    annualIncrease: 'augmentation annuelle de la violence signalée',
    
    // NEW: Organizational Health Section
    organizationalHealth: 'Santé Organisationnelle',
    organizationalHealthDescription: "Métriques de satisfaction et d'engagement des membres de JCI Brésil",
    netPromoterScore: 'Net Promoter Score',
    excellent: 'Excellent',
    promoters: 'Promoteurs',
    passives: 'Passifs',
    detractors: 'Détracteurs',
    localSatisfaction: 'Satisfaction Org. Locale',
    nationalSatisfaction: 'Satisfaction Org. Nationale',
    outOfTen: 'sur 10',
    npsBreakdown: 'Répartition NPS',
    satisfactionScores: 'Scores de Satisfaction',
    
    // NEW: SWOT Analysis Section
    swotAnalysis: 'Analyse SWOT des Membres',
    swotAnalysisDescription: 'Évaluation stratégique du sondage des membres de JCI Brésil',
    strengths: 'Forces',
    weaknesses: 'Faiblesses',
    opportunities: 'Opportunités',
    threats: 'Menaces',
    membersIdentified: 'des membres ont identifié',
    
    // NEW: Geographic Distribution Section
    geographicGap: 'Distribution Géographique',
    geographicGapDescription: 'Concentration des membres de JCI Brésil par état',
    stateConcentration: 'Concentration par État',
    southRegionDominance: 'Dominance de la Région Sud',
    expansionOpportunity: "Opportunité d'Expansion",
    expansionOpportunityText: 'Présence minimale dans les régions Nord/Nord-Est où les besoins de développement des jeunes sont les plus importants',
    members: 'membres',
    ofMembership: 'des membres',
    
    // NEW: Training Insights Section
    trainingInsights: 'Participation aux Formations',
    trainingInsightsDescription: 'Taux de complétion des cours de formation de JCI Brésil',
    noTrainingCompleted: 'Aucune Formation Complétée',
    trainingGapAlert: "des membres n'ont complété aucun cours de formation JCI",
    courseCompletionRates: 'Taux de Complétion des Cours',
    completionRate: 'Complétion',
    
    // NEW: SDG Preferences Section  
    sdgPreferences: 'Priorités des Membres en ODD',
    sdgPreferencesDescription: 'Principaux ODD intéressant les membres de JCI Brésil (3 prochaines années)',
    memberInterest: 'Intérêt des Membres',
    topPriority: 'Priorité Principale',
    alignsWithNationalNeeds: 'Aligné avec les défis nationaux de la jeunesse',
    
    // Sample label
    sample: 'Échantillon',

    // SWOT Items (20 keys)
    swotItems: {
      companionship: 'Camaraderie',
      committedLeadership: 'Leadership engagé',
      continuousTraining: 'Formation continue',
      purposeInDna: 'Mission dans l\'ADN',
      qualityNetworking: 'Réseautage de qualité',
      inflatedEgos: 'Egos surdimensionnés',
      bureaucracy: 'Bureaucratie',
      inconclusiveProcesses: 'Processus non concluants',
      closedOrganization: 'Organisation fermée',
      lackOfMarketing: 'Manque de marketing',
      grantsAndSponsorships: 'Subventions et parrainages',
      personalDevelopmentNecessity: 'Nécessité de développement personnel',
      marketDemandsNewLeaders: 'Le marché demande de nouveaux leaders',
      digitalPlatforms: 'Plateformes numériques',
      digitalMarketing: 'Marketing numérique',
      rapidSocietalChange: 'Changement comportemental rapide de la société',
      digitalEntertainment: 'Divertissement numérique',
      growingNgos: 'Nombre croissant d\'ONG sociales',
      lackOfRecognizedProjects: 'Manque de projets reconnus',
      societyWithoutTime: 'Société sans temps',
    },

    // SDG Titles (9 keys)
    sdgTitles: {
      qualityEducation: 'Éducation de Qualité',
      goodHealth: 'Bonne Santé et Bien-être',
      decentWork: 'Travail Décent et Croissance Économique',
      peaceJustice: 'Paix, Justice et Institutions Efficaces',
      reducedInequalities: 'Inégalités Réduites',
      genderEquality: 'Égalité entre les Sexes',
      noPoverty: 'Pas de Pauvreté',
      sustainableCities: 'Villes et Communautés Durables',
      climateAction: 'Mesures Relatives au Climat',
    },

    // Training Courses (10 keys)
    trainingCourses: {
      jciImpact: 'JCI Impact',
      jciAchieve: 'JCI Achieve',
      projectManagement: 'Gestion de Projet',
      jciAdmin: 'JCI Admin',
      effectiveLeadership: 'Leadership Efficace',
      networking: 'Réseautage',
      communications: 'Communications',
      presenter: 'Présentateur',
      leadershipAcademy: 'Académie de Leadership',
      jciDiscover: 'JCI Discover',
    },

    // Brazil-specific Demographics
    brazilDemographics: {
      urbanPopulationBrazil: 'Majorité urbaine, ~16M dans les favelas',
    },

    // Research Methodologies (5 keys)
    methodologies: {
      methodologyAtlas: 'Recherche en trois étapes : analyse quantitative (données IBGE), entretiens qualitatifs, recommandations politiques',
      methodologySuaVoz: 'SurveyMonkey, 40,7% de taux de réponse, ±4% de marge d\'erreur, 95% de confiance',
      methodologyConjuve: 'Enquête nationale sur les attitudes et défis des jeunes',
      methodologyConvid: 'Enquête comportementale sur la santé mentale des adolescents',
      methodologyAtlasViolencia: 'Analyse des données d\'homicides et de violence',
    },

    // Brazil-specific Recommendations (12 keys)
    brazilRecommendations: {
      urgentRec1: 'Traiter la crise NEET des femmes noires/métisses (taux de 43,3%)',
      urgentRec2: 'Étendre les programmes de santé mentale pour l\'anxiété climatique',
      urgentRec3: 'Lancer des sections régionales dans le Nord/Nord-Est',
      urgentRec4: 'Partenariat avec CUFA pour atteindre les communautés des favelas',
      mediumRec1: 'Étendre les programmes NextGen et JOAJU IT à l\'échelle nationale',
      mediumRec2: 'Développer des parcours éducatifs spécifiques à JCI',
      mediumRec3: 'Créer une formation d\'ambassadeurs en santé mentale pour les membres',
      mediumRec4: 'Construire des partenariats formels avec les réseaux de femmes entrepreneures',
      longRec1: 'Positionner JCI Brésil comme partenaire clé pour l\'agenda jeunesse de la COP 30',
      longRec2: 'Aborder la transition démographique avec un investissement stratégique dans la jeunesse',
      longRec3: 'Atteindre l\'équilibre de genre 50-50 avec un focus sur l\'équité raciale',
      longRec4: 'Établir une présence dans les 27 états brésiliens',
    },
  },
};
